<template>
    <div class="row pt-1">
        <small v-if="messages" class="mb-0 pb-0" v-html="messages" />
        <ob1-legal-notice
            class="py-1"
            :button-id="title + 'Id'"
            :button-label="title"
            :collapsed-block-id="title + 'CollapsedId'"
        >
            <ul class="list-unstyled">
                <li
                    v-for="(mention, index) in mentions"
                    :key="'mention-' + index"
                    class="mb-1"
                >
                    <small v-html="mention" />
                </li>
            </ul>
        </ob1-legal-notice>
    </div>
</template>

<script>

export default {
    name: "MobileRecoveryLegalMentions",
    props: {
        title: {
            type: String,
            required: true
        },
        messages: {
            type: String,
            default: null
        },
        mentions: {
            type: Array,
            required: true
        }
    }
}
</script>

<style  lang="scss" scoped>
.parenthesis-numbers {
    list-style-type: none;
}

.parenthesis-numbers li {
    counter-increment: item;
    margin-left: 2em;
}

.parenthesis-numbers li::before {
    content: "(" counter(item) ") ";
    display: inline-block;
    width: 2em;
    margin-left: -2em;
}
</style>
